<template>
  <v-container fluid>
    <v-card flat>
      <v-tabs>
        <v-tab class="white black--text">
          <v-icon color="black" left> mdi-finance </v-icon>
          Commerciale
        </v-tab>
        <v-tab class="white black--text">
          <v-icon color="black" left> mdi-finance </v-icon>
          Production
        </v-tab>
        <v-tab class="white black--text">
          <v-icon color="black" left> mdi-ambulance </v-icon>
          Sinistre
        </v-tab>
        <v-tab class="white black--text">
          <v-icon color="black" left> mdi-access-point </v-icon>
          Recap
        </v-tab>
        <v-tab-item key="1">
          <v-card flat>
            <v-tabs background-color="#0482fb" class="white--text" dark
              next-icon="mdi-arrow-right-bold-box-outline white--text"
              prev-icon="mdi-arrow-left-bold-box-outline white--text" show-arrows>
              <v-tabs-slider color="white"></v-tabs-slider>
              <v-tab>Listing Appel</v-tab>
              <v-tab>Listing Rendez-vous</v-tab>
              <v-tab>Listing Client</v-tab>
              <v-tab>Listing Prospect</v-tab>
              <v-tab>Listing Courrier</v-tab>
              <v-tab-item key="1">
                <ChartCall />
              </v-tab-item>
              <v-tab-item key="2">
                <ChartRdv />
              </v-tab-item>
              <v-tab-item key="3">
                <ChartClient />
              </v-tab-item>
              <v-tab-item key="4">
                <ChartProspect />
              </v-tab-item>
              <v-tab-item key="5">
                <ChartCourrier />
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-tab-item>
        <v-tab-item key="2">
          <v-card flat>
            <v-tabs background-color="#0482fb" class="white--text" dark
              next-icon="mdi-arrow-right-bold-box-outline white--text"
              prev-icon="mdi-arrow-left-bold-box-outline white--text" show-arrows>
              <v-tabs-slider color="white"></v-tabs-slider>
              <v-tab>Listing Cotation</v-tab>
              <v-tab>Listing Emission</v-tab>
              <v-tab>Listing Impayés</v-tab>
              <v-tab>Listing En attente de Reversement</v-tab>
              <v-tab>Listing Reversement</v-tab>

              <v-tab>Listing Chiffre d'affaires</v-tab>

              <v-tab>Listing échéance</v-tab>
              <v-tab>Listing Coassurance</v-tab>
              <v-tab>Listing Régularisation</v-tab>
              <v-tab>Listing Participation Bénéficiaire</v-tab>
              <v-tab>Listing Réassurance</v-tab>

              <v-tab-item key="1">
                <ChartCotation />
              </v-tab-item>
              <v-tab-item key="2">
                <ChartEmission />
              </v-tab-item>
              <v-tab-item key="3">
                <Impayer />
              </v-tab-item>
              <v-tab-item key="4">
                <ChartReversement />
              </v-tab-item>
              <v-tab-item key="5">
                <chartEncaissement />
              </v-tab-item>

              <v-tab-item key="6">
                <chartPaiement />
              </v-tab-item>
              <v-tab-item key="7">
                <chartecheance />
              </v-tab-item>
              <v-tab-item key="8">
                <chartCoassurance />
              </v-tab-item>
              <v-tab-item key="9">
                <chartRegulation />
              </v-tab-item>
              <v-tab-item key="10">
                <chartpb />
              </v-tab-item>
              <v-tab-item key="11">
                <chartReassure />
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-tab-item>
        <v-tab-item key="3">
          <v-card flat>
            <v-tabs background-color="#0482fb" dark next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline" show-arrows>
              <v-tabs-slider color="white"></v-tabs-slider>
              <v-tab>Listing Déclaration </v-tab>
              <v-tab>Listing PV</v-tab>
              <v-tab>Listing Bon</v-tab>
              <v-tab>Listing Expertise</v-tab>
              <v-tab>Listing Règlements</v-tab>
              <v-tab>Listing Inventaire</v-tab>
              <v-tab-item key="1">
                <chartSinistre />
              </v-tab-item>
              <v-tab-item key="2">
                <chartPv />
              </v-tab-item>
              <v-tab-item key="3">
                <chartBon />
              </v-tab-item>
              <v-tab-item key="4">
                <chartExpertise />
              </v-tab-item>
              <v-tab-item key="5">
                <chartOffres />
              </v-tab-item>
              <v-tab-item key="6">
                <chartInventaire />
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-tab-item>
        <v-tab-item key="4">
          <v-tabs background-color="#0482fb" dark next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline" show-arrows>
            <v-tabs-slider color="white"></v-tabs-slider>
            <v-tab>Recapitulatif Production DAYO GS</v-tab>
            <v-tab>Recapitulatif Production Compagnie</v-tab>
            <v-tab disabled>Recapitulatif sinistre DAYO GS</v-tab>
            <v-tab disabled>Recapitulatif sinistre Compagnie</v-tab>
            <v-tab-item key="1">
              <recapAsk />
            </v-tab-item>
            <v-tab-item key="1">
              <recapAll />
            </v-tab-item>
          </v-tabs>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>
<script>
import ChartCall from "../components/Commerciale/appel.vue";
import ChartRdv from "../components/Commerciale/rdv.vue";
import ChartClient from "../components/Commerciale/client.vue";
import ChartProspect from "../components/Commerciale/prospect.vue";
import ChartCotation from "../components/production/cotation.vue";
import ChartCourrier from "../components/Commerciale/courrier.vue";
import ChartEmission from "../components/production/emission.vue";
import chartEncaissement from "../components/production/encaissement.vue";
import chartCoassurance from "../components/production/coassurance.vue";
import chartRegulation from "../components/production/regul.vue";
import chartpb from "../components/production/participation.vue";
import chartReassure from "../components/production/reassur.vue";
import chartInventaire from "../components/sinistre/inventaire.vue";
import chartSinistre from "../components/sinistre/sinistre.vue";
import chartPv from "../components/sinistre/pv.vue";
import chartBon from "../components/sinistre/bon.vue";
import chartExpertise from "../components/sinistre/expertise.vue";
import chartOffres from "../components/sinistre/offres.vue";
import chartPaiement from "../components/production/paiement.vue";
import chartecheance from "../components/production/echeance.vue";
import recapAll from "../components/recap/recap.vue";
import recapAsk from "../components/recap/recapAsk.vue";
import Impayer from "../components/production/impayer.vue";
import ChartReversement from "../components/production/reversement.vue"

export default {
  name: "chart",
  components: {
    recapAll,
    ChartCall,
    ChartRdv,
    ChartClient,
    ChartProspect,
    ChartReversement,
    ChartCotation,
    ChartCourrier,
    ChartEmission,
    chartEncaissement,
    chartCoassurance,
    chartRegulation,
    chartpb,
    chartReassure,
    chartSinistre,
    chartPv,
    chartBon,
    chartExpertise,
    chartOffres,
    chartInventaire,
    chartPaiement,
    Impayer,
    chartecheance,
    recapAsk,
  },
};
</script>
